/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedAccountsRouteRouteImport } from './routes/_authed/accounts/route'
import { Route as AuthedForbiddenRouteImport } from './routes/_authed/forbidden'
import { Route as AuthedProfilesRouteRouteImport } from './routes/_authed/profiles/route'
import { Route as AuthedTeamsRouteRouteImport } from './routes/_authed/teams/route'
import { Route as AuthedTrashRouteImport } from './routes/_authed/trash'
import { Route as AuthedUsersRouteImport } from './routes/_authed/users'
import { Route as AuthedAccountsIndexRouteImport } from './routes/_authed/accounts/index'
import { Route as AuthedAccountsUuidRouteImport } from './routes/_authed/accounts/$uuid'
import { Route as AuthedAccountsFindRouteImport } from './routes/_authed/accounts/find'
import { Route as AuthedAccountsLinkRouteImport } from './routes/_authed/accounts/link'
import { Route as AuthedProfilesIndexRouteImport } from './routes/_authed/profiles/index'
import { Route as AuthedProfilesUuidRouteImport } from './routes/_authed/profiles/$uuid'
import { Route as AuthedProfilesNewRouteImport } from './routes/_authed/profiles/new'
import { Route as AuthedTeamsIndexRouteImport } from './routes/_authed/teams/index'
import { Route as AuthedTeamsUuidRouteImport } from './routes/_authed/teams/$uuid'
import { Route as AuthedTeamsNewRouteImport } from './routes/_authed/teams/new'
import { Route as AuthedTeamsUuidMembersRouteImport } from './routes/_authed/teams/$uuid_.members'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountsRouteRoute = AuthedAccountsRouteRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedForbiddenRoute = AuthedForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfilesRouteRoute = AuthedProfilesRouteRouteImport.update({
  id: '/profiles',
  path: '/profiles',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTeamsRouteRoute = AuthedTeamsRouteRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTrashRoute = AuthedTrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedUsersRoute = AuthedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountsIndexRoute = AuthedAccountsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAccountsRouteRoute,
} as any)
const AuthedAccountsUuidRoute = AuthedAccountsUuidRouteImport.update({
  id: '/$uuid',
  path: '/$uuid',
  getParentRoute: () => AuthedAccountsRouteRoute,
} as any)
const AuthedAccountsFindRoute = AuthedAccountsFindRouteImport.update({
  id: '/find',
  path: '/find',
  getParentRoute: () => AuthedAccountsRouteRoute,
} as any)
const AuthedAccountsLinkRoute = AuthedAccountsLinkRouteImport.update({
  id: '/link',
  path: '/link',
  getParentRoute: () => AuthedAccountsRouteRoute,
} as any)
const AuthedProfilesIndexRoute = AuthedProfilesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedProfilesRouteRoute,
} as any)
const AuthedProfilesUuidRoute = AuthedProfilesUuidRouteImport.update({
  id: '/$uuid',
  path: '/$uuid',
  getParentRoute: () => AuthedProfilesRouteRoute,
} as any)
const AuthedProfilesNewRoute = AuthedProfilesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthedProfilesRouteRoute,
} as any)
const AuthedTeamsIndexRoute = AuthedTeamsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedTeamsRouteRoute,
} as any)
const AuthedTeamsUuidRoute = AuthedTeamsUuidRouteImport.update({
  id: '/$uuid',
  path: '/$uuid',
  getParentRoute: () => AuthedTeamsRouteRoute,
} as any)
const AuthedTeamsNewRoute = AuthedTeamsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthedTeamsRouteRoute,
} as any)
const AuthedTeamsUuidMembersRoute = AuthedTeamsUuidMembersRouteImport.update({
  id: '/$uuid_/members',
  path: '/$uuid/members',
  getParentRoute: () => AuthedTeamsRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/auth': typeof AuthRoute
  '/login': typeof LoginRoute
  '/accounts': typeof AuthedAccountsRouteRouteWithChildren
  '/profiles': typeof AuthedProfilesRouteRouteWithChildren
  '/teams': typeof AuthedTeamsRouteRouteWithChildren
  '/forbidden': typeof AuthedForbiddenRoute
  '/trash': typeof AuthedTrashRoute
  '/users': typeof AuthedUsersRoute
  '/accounts/$uuid': typeof AuthedAccountsUuidRoute
  '/accounts/find': typeof AuthedAccountsFindRoute
  '/accounts/link': typeof AuthedAccountsLinkRoute
  '/profiles/$uuid': typeof AuthedProfilesUuidRoute
  '/profiles/new': typeof AuthedProfilesNewRoute
  '/teams/$uuid': typeof AuthedTeamsUuidRoute
  '/teams/new': typeof AuthedTeamsNewRoute
  '/accounts/': typeof AuthedAccountsIndexRoute
  '/profiles/': typeof AuthedProfilesIndexRoute
  '/teams/': typeof AuthedTeamsIndexRoute
  '/teams/$uuid/members': typeof AuthedTeamsUuidMembersRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRoute
  '/login': typeof LoginRoute
  '/forbidden': typeof AuthedForbiddenRoute
  '/trash': typeof AuthedTrashRoute
  '/users': typeof AuthedUsersRoute
  '/': typeof AuthedIndexRoute
  '/accounts/$uuid': typeof AuthedAccountsUuidRoute
  '/accounts/find': typeof AuthedAccountsFindRoute
  '/accounts/link': typeof AuthedAccountsLinkRoute
  '/profiles/$uuid': typeof AuthedProfilesUuidRoute
  '/profiles/new': typeof AuthedProfilesNewRoute
  '/teams/$uuid': typeof AuthedTeamsUuidRoute
  '/teams/new': typeof AuthedTeamsNewRoute
  '/accounts': typeof AuthedAccountsIndexRoute
  '/profiles': typeof AuthedProfilesIndexRoute
  '/teams': typeof AuthedTeamsIndexRoute
  '/teams/$uuid/members': typeof AuthedTeamsUuidMembersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/auth': typeof AuthRoute
  '/login': typeof LoginRoute
  '/_authed/accounts': typeof AuthedAccountsRouteRouteWithChildren
  '/_authed/profiles': typeof AuthedProfilesRouteRouteWithChildren
  '/_authed/teams': typeof AuthedTeamsRouteRouteWithChildren
  '/_authed/forbidden': typeof AuthedForbiddenRoute
  '/_authed/trash': typeof AuthedTrashRoute
  '/_authed/users': typeof AuthedUsersRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/accounts/$uuid': typeof AuthedAccountsUuidRoute
  '/_authed/accounts/find': typeof AuthedAccountsFindRoute
  '/_authed/accounts/link': typeof AuthedAccountsLinkRoute
  '/_authed/profiles/$uuid': typeof AuthedProfilesUuidRoute
  '/_authed/profiles/new': typeof AuthedProfilesNewRoute
  '/_authed/teams/$uuid': typeof AuthedTeamsUuidRoute
  '/_authed/teams/new': typeof AuthedTeamsNewRoute
  '/_authed/accounts/': typeof AuthedAccountsIndexRoute
  '/_authed/profiles/': typeof AuthedProfilesIndexRoute
  '/_authed/teams/': typeof AuthedTeamsIndexRoute
  '/_authed/teams/$uuid_/members': typeof AuthedTeamsUuidMembersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/login'
    | '/accounts'
    | '/profiles'
    | '/teams'
    | '/forbidden'
    | '/trash'
    | '/users'
    | '/accounts/$uuid'
    | '/accounts/find'
    | '/accounts/link'
    | '/profiles/$uuid'
    | '/profiles/new'
    | '/teams/$uuid'
    | '/teams/new'
    | '/accounts/'
    | '/profiles/'
    | '/teams/'
    | '/teams/$uuid/members'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/login'
    | '/forbidden'
    | '/trash'
    | '/users'
    | '/'
    | '/accounts/$uuid'
    | '/accounts/find'
    | '/accounts/link'
    | '/profiles/$uuid'
    | '/profiles/new'
    | '/teams/$uuid'
    | '/teams/new'
    | '/accounts'
    | '/profiles'
    | '/teams'
    | '/teams/$uuid/members'
  id:
    | '__root__'
    | '/_authed'
    | '/auth'
    | '/login'
    | '/_authed/accounts'
    | '/_authed/profiles'
    | '/_authed/teams'
    | '/_authed/forbidden'
    | '/_authed/trash'
    | '/_authed/users'
    | '/_authed/'
    | '/_authed/accounts/$uuid'
    | '/_authed/accounts/find'
    | '/_authed/accounts/link'
    | '/_authed/profiles/$uuid'
    | '/_authed/profiles/new'
    | '/_authed/teams/$uuid'
    | '/_authed/teams/new'
    | '/_authed/accounts/'
    | '/_authed/profiles/'
    | '/_authed/teams/'
    | '/_authed/teams/$uuid_/members'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  AuthRoute: typeof AuthRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/accounts': {
      id: '/_authed/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AuthedAccountsRouteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/forbidden': {
      id: '/_authed/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof AuthedForbiddenRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/profiles': {
      id: '/_authed/profiles'
      path: '/profiles'
      fullPath: '/profiles'
      preLoaderRoute: typeof AuthedProfilesRouteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/teams': {
      id: '/_authed/teams'
      path: '/teams'
      fullPath: '/teams'
      preLoaderRoute: typeof AuthedTeamsRouteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/trash': {
      id: '/_authed/trash'
      path: '/trash'
      fullPath: '/trash'
      preLoaderRoute: typeof AuthedTrashRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/users': {
      id: '/_authed/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthedUsersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/accounts/': {
      id: '/_authed/accounts/'
      path: '/'
      fullPath: '/accounts/'
      preLoaderRoute: typeof AuthedAccountsIndexRouteImport
      parentRoute: typeof AuthedAccountsRouteRoute
    }
    '/_authed/accounts/$uuid': {
      id: '/_authed/accounts/$uuid'
      path: '/$uuid'
      fullPath: '/accounts/$uuid'
      preLoaderRoute: typeof AuthedAccountsUuidRouteImport
      parentRoute: typeof AuthedAccountsRouteRoute
    }
    '/_authed/accounts/find': {
      id: '/_authed/accounts/find'
      path: '/find'
      fullPath: '/accounts/find'
      preLoaderRoute: typeof AuthedAccountsFindRouteImport
      parentRoute: typeof AuthedAccountsRouteRoute
    }
    '/_authed/accounts/link': {
      id: '/_authed/accounts/link'
      path: '/link'
      fullPath: '/accounts/link'
      preLoaderRoute: typeof AuthedAccountsLinkRouteImport
      parentRoute: typeof AuthedAccountsRouteRoute
    }
    '/_authed/profiles/': {
      id: '/_authed/profiles/'
      path: '/'
      fullPath: '/profiles/'
      preLoaderRoute: typeof AuthedProfilesIndexRouteImport
      parentRoute: typeof AuthedProfilesRouteRoute
    }
    '/_authed/profiles/$uuid': {
      id: '/_authed/profiles/$uuid'
      path: '/$uuid'
      fullPath: '/profiles/$uuid'
      preLoaderRoute: typeof AuthedProfilesUuidRouteImport
      parentRoute: typeof AuthedProfilesRouteRoute
    }
    '/_authed/profiles/new': {
      id: '/_authed/profiles/new'
      path: '/new'
      fullPath: '/profiles/new'
      preLoaderRoute: typeof AuthedProfilesNewRouteImport
      parentRoute: typeof AuthedProfilesRouteRoute
    }
    '/_authed/teams/': {
      id: '/_authed/teams/'
      path: '/'
      fullPath: '/teams/'
      preLoaderRoute: typeof AuthedTeamsIndexRouteImport
      parentRoute: typeof AuthedTeamsRouteRoute
    }
    '/_authed/teams/$uuid': {
      id: '/_authed/teams/$uuid'
      path: '/$uuid'
      fullPath: '/teams/$uuid'
      preLoaderRoute: typeof AuthedTeamsUuidRouteImport
      parentRoute: typeof AuthedTeamsRouteRoute
    }
    '/_authed/teams/new': {
      id: '/_authed/teams/new'
      path: '/new'
      fullPath: '/teams/new'
      preLoaderRoute: typeof AuthedTeamsNewRouteImport
      parentRoute: typeof AuthedTeamsRouteRoute
    }
    '/_authed/teams/$uuid_/members': {
      id: '/_authed/teams/$uuid_/members'
      path: '/$uuid/members'
      fullPath: '/teams/$uuid/members'
      preLoaderRoute: typeof AuthedTeamsUuidMembersRouteImport
      parentRoute: typeof AuthedTeamsRouteRoute
    }
  }
}

interface AuthedAccountsRouteRouteChildren {
  AuthedAccountsUuidRoute: typeof AuthedAccountsUuidRoute
  AuthedAccountsFindRoute: typeof AuthedAccountsFindRoute
  AuthedAccountsLinkRoute: typeof AuthedAccountsLinkRoute
  AuthedAccountsIndexRoute: typeof AuthedAccountsIndexRoute
}

const AuthedAccountsRouteRouteChildren: AuthedAccountsRouteRouteChildren = {
  AuthedAccountsUuidRoute: AuthedAccountsUuidRoute,
  AuthedAccountsFindRoute: AuthedAccountsFindRoute,
  AuthedAccountsLinkRoute: AuthedAccountsLinkRoute,
  AuthedAccountsIndexRoute: AuthedAccountsIndexRoute,
}

const AuthedAccountsRouteRouteWithChildren =
  AuthedAccountsRouteRoute._addFileChildren(AuthedAccountsRouteRouteChildren)

interface AuthedProfilesRouteRouteChildren {
  AuthedProfilesUuidRoute: typeof AuthedProfilesUuidRoute
  AuthedProfilesNewRoute: typeof AuthedProfilesNewRoute
  AuthedProfilesIndexRoute: typeof AuthedProfilesIndexRoute
}

const AuthedProfilesRouteRouteChildren: AuthedProfilesRouteRouteChildren = {
  AuthedProfilesUuidRoute: AuthedProfilesUuidRoute,
  AuthedProfilesNewRoute: AuthedProfilesNewRoute,
  AuthedProfilesIndexRoute: AuthedProfilesIndexRoute,
}

const AuthedProfilesRouteRouteWithChildren =
  AuthedProfilesRouteRoute._addFileChildren(AuthedProfilesRouteRouteChildren)

interface AuthedTeamsRouteRouteChildren {
  AuthedTeamsUuidRoute: typeof AuthedTeamsUuidRoute
  AuthedTeamsNewRoute: typeof AuthedTeamsNewRoute
  AuthedTeamsIndexRoute: typeof AuthedTeamsIndexRoute
  AuthedTeamsUuidMembersRoute: typeof AuthedTeamsUuidMembersRoute
}

const AuthedTeamsRouteRouteChildren: AuthedTeamsRouteRouteChildren = {
  AuthedTeamsUuidRoute: AuthedTeamsUuidRoute,
  AuthedTeamsNewRoute: AuthedTeamsNewRoute,
  AuthedTeamsIndexRoute: AuthedTeamsIndexRoute,
  AuthedTeamsUuidMembersRoute: AuthedTeamsUuidMembersRoute,
}

const AuthedTeamsRouteRouteWithChildren =
  AuthedTeamsRouteRoute._addFileChildren(AuthedTeamsRouteRouteChildren)

interface AuthedRouteChildren {
  AuthedAccountsRouteRoute: typeof AuthedAccountsRouteRouteWithChildren
  AuthedProfilesRouteRoute: typeof AuthedProfilesRouteRouteWithChildren
  AuthedTeamsRouteRoute: typeof AuthedTeamsRouteRouteWithChildren
  AuthedForbiddenRoute: typeof AuthedForbiddenRoute
  AuthedTrashRoute: typeof AuthedTrashRoute
  AuthedUsersRoute: typeof AuthedUsersRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAccountsRouteRoute: AuthedAccountsRouteRouteWithChildren,
  AuthedProfilesRouteRoute: AuthedProfilesRouteRouteWithChildren,
  AuthedTeamsRouteRoute: AuthedTeamsRouteRouteWithChildren,
  AuthedForbiddenRoute: AuthedForbiddenRoute,
  AuthedTrashRoute: AuthedTrashRoute,
  AuthedUsersRoute: AuthedUsersRoute,
  AuthedIndexRoute: AuthedIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  AuthRoute: AuthRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
